<template>
    <div>
         <!-- <headEnterprise></headEnterprise> -->
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                   <sidebar></sidebar> 
                </el-aside>
                <el-main>
                    <contTitle  :obj="obj" :contTitle="contTitle"></contTitle>
                    <companySide class="mt-30" :isButton="isButton"></companySide>
                    <div class="mt-30">
                        <paletteBar :paletteObj="paletteObj" @onPaletteBar="addCase()" @onDelPalet="delCase()" @onEditPalet="editCase()"  @onViewPalet="viewCase()"></paletteBar>
                        <div class="mt-10">
                            <div class="corporate_middle">                               
                               <div class= "middle_cont" v-for="(item,index) in list " :key="index">
                                    <div class="middle_cont_left" @click="onView(item)">
                                         <img :src="item.cover" alt="">
                                    </div>
                                    <p class="title_far">{{item.title}}</p>
                                    <div class="middle_text fdc"> 
                                       <p>{{item.createtime.substring(0,10)}}</p>
                                        <p>
                                            <span>浏览数 : </span><span>{{item.visitcount}}</span>
                                        </p>
                                    </div>
                                    <div class="place fcc" @click="onDetail(item)">
                                        <el-checkbox-group v-model="checkList" @change="onChange">
                                            <el-checkbox :label="item.id"></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                               </div>
                            </div>           
                        </div>
                        <!--分页-->
                         <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>
                        
                        <div style="margin-top:20%">
                          <notList :notCode="notCode"></notList>
                       </div>
                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {getToken} from '@/utils/auth'
import {delRelease,releaseList,eidRelease} from "@/api/company"
import headEnterprise from "../../common/headEnterprise"
import {routerGoNewpage} from "@/utils/index"
import sidebar from '../../common/sidebar'
import companySide from '../../common/companySide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import paletteBar from '../../common/paletteBar'
import contTitle from '../../common/contTitle'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
  components:{
     headEnterprise, sidebar,companySide,commBanner,titleHead,paletteBar,contTitle,Pagination,notList
  }, 
  data(){
      return{
        headTitle:'企业资讯',
        contTitle:'企业基本信息',
        obj:{
           title:'经典案例',   
           isShow:false,
           isColor:false,
           roleType:3,
           personalType:9
        },
         paletteObj:{
            paletteTitle:'企业案例',
            paletteCount:3,
            paletteName:'添加案例',
            paletteText:'删除案例',
		      	paletteView:'编辑案例',
            isShow:false,
            isDelete:true,
		      	isEdit:true
        },
        list:[],
        delId:'',
        listQuery:{
          curPage:1,
          limit:6
        },
        total:0,//总条数
        checkList:[],
        isButton:false,
        notCode:false,
		    caseId:''
      }
  },
  created(){
      this.getList();
  },
  methods:{
      //添加案列
      addCase(){
         this.$router.push('/corporate_caseAdd')
      },
	  //编辑案例
	  editCase(){
		 if(this.checkList.length ==0){
		   this.$message({
		     message:'至少选择一条数据',
		     type:"warning",
		     duration:1000,
		   });
		  }else{
			  this.$router.push({
			  	 path:'/corporate_caseAdd',
			  	 query:{id:this.caseId}
			  });  
		  }

	  },
      //获取列表
      getList(){
        releaseList(this.listQuery).then(res=>{
            if(res.code ==0){
                this.list = res.page.list;
                this.total = res.page.totalCount;
                this.list.length == 0 ? this.notCode = true : this.notCode = false;
            }
        }).catch(err=>{});
      },
      //删除案例
      delCase(){
        if(this.checkList.length ==0){
          this.$message({
            message:'至少选择一条数据',
            type:"warning",
            duration:1000,
          });
        }else{
        let params = {id:this.delId};
        this.$confirm('确定要删除吗','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          delRelease(params).then((res)=>{
          if(res.code ==0){
             this.$message({
                message:'删除成功！',
                type: 'success',
                duration:1000,
                onClose:()=>{
                  this.getList();
                }
             });
          }
         }).catch((err)=>{});
        }).catch(()=>{
         this.$message({
            type: 'info',
            message: '已取消删除'
          });
        })
        }
      },
      onChange(){
        this.checkList.forEach(item =>{
             this.delId = item;
        });
      },
      //分页
      pageChange(item){
        this.listQuery['curPage'] = item.page;
        this.listQuery['limit'] = item.limit;
        this.getList();
      },
	    onDetail(data){
		    this.caseId = data.id;
      },
      viewCase(){},
      onView(item){
         routerGoNewpage('/corporate_case_detail',{id:item.id})  
      },
  }
}
</script>
<style scoped="scoped">
.el-aside{
    height:100%;
}
.mt-30{
    margin-top: 30px;
}
.corporate_top img{
    width: 65%;
    height: 286px;
}
.corporate_top div{
    height: 286px;
    background: #02B854;
    padding: 40px 30px;
    text-align: left;
}
.corporate_top div p:first-child{ 
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FEFEFE;
}
.corporate_top div p:nth-child(2){    
    margin-top: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FEFEFE;
    line-height: 24px;
}
.corporate_top div p:last-child{   
    margin-top: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FEFEFE;
}
.corporate_middle{
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.corporate_middle::after{
  content:'';
  width: 218px;
}
.middle_cont{
    width: 31%;
    text-align: left;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}
.middle_cont_left{
    overflow: hidden;
}
.middle_cont_left img{
    width: 100%;
    height: 162px;
    transition: all 0.6s;
}
.middle_cont_left img:hover{
    transform: scale(1.4);
}
.middle_cont p:nth-child(1){   
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.middle_text{
    margin-top:5px;
}
.middle_text p:nth-child(1){
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;  
}
.middle_text p:nth-child(2){   
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
}

.el-pagination{
   margin-top: 40px;
}
.place{
    margin-top: 10px;
}
.title_far{
   overflow: hidden;
   display: -webkit-box;
   -webkit-box-orient: vertical;
   -webkit-line-clamp: 2;
   height: 38px;
   font-size: 14px;
   margin-top: 5px;
}

.corporate_middle>>>.el-checkbox__label{
  display: none;
}
.place>>> .el-checkbox__inner {
  border-radius: 50%;
  width: 18px;
  height: 18px;
  border: 1px solid #50b035;
}
.place >>>.el-checkbox__inner::after{
    height: 10px;
    left: 6px;
    position: absolute;
    top: 1px;
} 
.place >>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #50b035;
}

.place >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #50b035;
  border-color: #50b035;
  border-radius: 50%;
}
.place >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #50b035;
}
.place >>> .el-checkbox__inner:hover {
  background-color: #50b035;
}

</style>


// WEBPACK FOOTER //
// src/view/company/corporate_case.vue